import React from "react";
import { BackButton } from "../../components/AtomComponents";
import { releaseAutomation } from "./ConfigDeployment";
import { ConfigField } from "./ConfigField";

function ReleaseToProd() {
  return (
    <>
      <div className="cell small-6 medium-6 px-one-line-data">
        <BackButton />
        <h3 className="small-12 margin-bottom-1">Deploy to Production Environment</h3>
      </div>
      <ConfigField
        releaseAutomation={releaseAutomation}
        endpoint="release-to-prod"
        type="prod"
      />
    </>
  );
}

export default ReleaseToProd;
